import { Card, Grid, MenuItem, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import FilterSelect from "../../../../components/select/filterSelect";
import CardSlipPayment from "../components/card-slip-payment/CardSlipPayment";
import FormComponent from "../../../../components/gernerateForm/FormComponent";
import formGeneratePaymentApplication from "./dataFormGenerate.data";
import { StudentApi } from "../../../../api/student/student.api";
import { mockDataCurrency } from "../../../../utils/mockData";
import { alertError, alertSuccess } from "../../../../components/alert/swal";
import { useTranslation } from "react-i18next";

const PaymentApplicationFee = ({
  student_id,
  id_student_register_payment,
  data,
}: {
  student_id: number;
  id_student_register_payment: number;
  data?: any;
}) => {
  const { t } = useTranslation();
  const [inputData, setInputData] = useState<any>({
    payment: {
      payment_date: "",
      payment_time: "",
      currency: "",
      amount: 0,
      payment_type: "",
      file_path: "",
    },
  });
  const [accountPayment, _setAccountPayment] = useState<any>({
    account_personal: "วิทยาลัยพุทธศาสตร์นานาชาติ", // i18n-ignore (translated at render site)
    account_name: "MAHACHULALONG",
    account_no: "633-2-51932-8",
    account_type: "savings",
  });

  const getPaymentInfo = async (
    student_id: number,
    id_student_register_payment: number
  ) => {
    const res = await StudentApi.fetchGetPaymentInfo(
      student_id,
      id_student_register_payment
    );
    const data = res.data;
    if (data.status < 300) {
      setInputData({
        payment: {
          payment_date: data.data?.payment_date ?? "",
          payment_time: data.data?.payment_time ?? "",
          currency: data.data?.payment_currency
            ? data.data?.payment_currency.toUpperCase()
            : "",
          amount: data.data?.payment_amount ?? 0,
          payment_type: data.data?.payment_type ?? "",
          file_path: data.data?.file_path,
        },
      });
    } else {
      setInputData({});
    }
  };

  useEffect(() => {
    if (student_id && id_student_register_payment) {
      getPaymentInfo(student_id, id_student_register_payment);
    }
  }, [student_id, id_student_register_payment]);

  const handleDownloadFile = async (
    student_id: number,
    id_student_certificate: number
  ) => {
    await StudentApi.fetchGetPaymentInfoDownload(
      student_id,
      id_student_certificate
    )
      .then((res) => {
        if (res.status < 300) {
          alertSuccess(t("สำเร็จ"), t("ดาวน์โหลดไฟล์เรียบร้อย"), t("ตกลง"));
        }
      })
      .catch((error) => alertError(t("ดาวน์โหลด ไม่สำเร็จ")))
      .finally(() => {});
  };
  return (
    <>
      <Card sx={{ marginBottom: 2, padding: 2, width: "100%" }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={1}>
            Image
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="subtitle1">
              {t("ชื่อบัญชี :")} <b>{t(accountPayment.account_personal)}</b>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="subtitle1">
              Account Name : <b>{accountPayment.account_name}</b>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2.5}>
            <Typography variant="subtitle1">
              Account No. : <b>{accountPayment.account_no}</b>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2.5}>
            <Typography variant="subtitle1">
              Account Type : <b>{accountPayment.account_type}</b>
            </Typography>
          </Grid>
        </Grid>

        <Card
          sx={{ marginTop: 4, padding: 1, width: "100%" }}
          style={{
            backgroundColor: "gray",
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={1}>
              <Typography variant="subtitle1" color={"white"}>
                Currency
              </Typography>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FilterSelect
                value={""}
                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {}}
                options={mockDataCurrency.map((item) => {
                  return (
                    <MenuItem
                      value={item.currency_name}
                      key={item.currency_name}
                    >
                      {item.currency_name}
                    </MenuItem>
                  );
                })}
                labelId={""}
                selectId={""}
              />
            </Grid>
            <Grid item xs={12} sm={7}>
              <Typography variant="subtitle1" color={"white"}>
                Bachelor of arts degree : Application fee 300 Thai Baht (THB)
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </Card>

      <CardSlipPayment
        file_path={inputData.file_path ?? null}
        onDownloadFile={() => {
          if (student_id && id_student_register_payment) {
            handleDownloadFile(student_id, id_student_register_payment);
          }
        }}
      />

      <FormComponent
        formGenerate={formGeneratePaymentApplication}
        inputValue={inputData}
        setInputValue={setInputData}
        handleCheckValid={false}
        isCanEdit={true}
        permission={"admin"}
      />
    </>
  );
};

export default PaymentApplicationFee;
